var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "line_expanded",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m6.5 15h-4c-.275 0-.5-.224-.5-.5v-13c0-.276.225-.5.5-.5h5.5v2.5c0 .827.673 1.5 1.5 1.5h2.5v.5c0 .276.224.5.5.5s.5-.224.5-.5v-.585c0-.4-.156-.777-.439-1.061l-3.415-3.415c-.279-.279-.666-.439-1.06-.439h-5.586c-.827 0-1.5.673-1.5 1.5v13c0 .827.673 1.5 1.5 1.5h4c.276 0 .5-.224.5-.5s-.224-.5-.5-.5zm4.793-11h-1.793c-.275 0-.5-.224-.5-.5v-1.793z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.5 7c-2.481 0-4.5 2.019-4.5 4.5s2.019 4.5 4.5 4.5 4.5-2.019 4.5-4.5-2.019-4.5-4.5-4.5zm0 8c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.854 9.146c-.195-.195-.512-.195-.707 0l-1.5 1.5c-.195.195-.195.512 0 .707s.512.195.707 0l.646-.646v2.793c0 .276.224.5.5.5s.5-.224.5-.5v-2.793l.646.646c.098.098.226.147.354.147s.256-.049.354-.146c.195-.195.195-.512 0-.707z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.41021a8e51401a8eeffcb1d03e0ea3a7.svg";
export { ForwardRef as ReactComponent };